import { render, staticRenderFns } from "./chargeMapping.vue?vue&type=template&id=c8ddf158&scoped=true&"
import script from "./chargeMapping.vue?vue&type=script&lang=js&"
export * from "./chargeMapping.vue?vue&type=script&lang=js&"
import style0 from "./chargeMapping.vue?vue&type=style&index=0&id=c8ddf158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ddf158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8ddf158')) {
      api.createRecord('c8ddf158', component.options)
    } else {
      api.reload('c8ddf158', component.options)
    }
    module.hot.accept("./chargeMapping.vue?vue&type=template&id=c8ddf158&scoped=true&", function () {
      api.rerender('c8ddf158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/chinaPostProductConfiguration/chargeMapping.vue"
export default component.exports